import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, themeColor } from '@elparking/components'

import { getMaxSpeedFromPlugs } from 'commons/js/components/ChargingPointSpeed'

const ChargingPointSpeedRoundedContainer = styled(Flex)`
    border: 1px solid ${themeColor('gray20')};
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    display: inline-flex;
`

ChargingPointSpeedRounded.propTypes = {
    plugs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string,
        speedChargingType: PropTypes.number,
    })),
}

function ChargingPointSpeedRounded ({plugs}) {
    const speedType = getMaxSpeedFromPlugs(plugs)

    return (
        speedType.speedTypeImage &&
        <ChargingPointSpeedRoundedContainer p='4px' alignItems='center' justifyContent='center' mr='8px'>
            <img height='12px' src={speedType.speedTypeImage} />
        </ChargingPointSpeedRoundedContainer>
    )
}

export default ChargingPointSpeedRounded
